(() => {
  const L_ = window.SVL_I18N || {};
  const V_ = (x) => (L_.vals && L_.vals[x]) || x;
  const pad = (i) => String(Number(i) + 1).padStart(2, "0");
  const MONTHS = (L_.months && L_.months.length === 12) ? L_.months : ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const CORTOS = (L_.monthsShort && L_.monthsShort.length === 12) ? L_.monthsShort : ["Jan.","Feb.","Mar.","Apr.","May","Jun.","Jul.","Aug.","Sep.","Oct.","Nov.","Dec."];

  document.querySelectorAll("[data-svb]").forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = "true";

    const config = JSON.parse(root.querySelector("[data-config]").textContent);
    const t = config.strings;
    const rings = [...root.querySelectorAll("[data-ring]")];
    const form = root.querySelector("form");
    const button = root.querySelector("[data-submit]");
    const error = root.querySelector("[data-error]");
    let quantity = Number(root.dataset.quantity) || 2;
    const slot1 = root.querySelector('[data-slot="1"]');
    const slot2 = root.querySelector('[data-slot="2"]');
    /* v2 — l'anneau 2 recopie l'anneau 1 tant que la cliente n'y a pas touché elle-même */
    const touche2 = { color: false, size: false, left: false, right: false };
    let enMiroir = false;
    function refleter() {
      if (enMiroir || rings.length < 2) return;
      enMiroir = true;
      try {
        if (!touche2.color) {
          const c1 = rings[0].querySelector("[data-color][aria-pressed=true]").dataset.color;
          rings[1].querySelectorAll("[data-color]").forEach((x) => x.setAttribute("aria-pressed", String(x.dataset.color === c1)));
          rings[1].querySelector("[data-color-label]").textContent = V_(c1);
        }
        [["size","size-2","size-1"],["left","left-2","left-1"],["right","right-2","right-1"]].forEach(([k, n2, n1]) => {
          if (touche2[k]) return;
          const s1 = root.querySelector('select[name="' + n1 + '"]');
          const s2 = root.querySelector('select[name="' + n2 + '"]');
          if (s1 && s2 && s1.value !== "" && s2.value !== s1.value) {
            s2.value = s1.value;
            s2.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      } finally { enMiroir = false; }
    }
    let busy = false;
    const pickers = [];

    /* ---------- size guide (one dialog, one link per ring) ---------- */
    const guide = root.querySelector("[data-guide]");
    const openGuide = () => { closePickers(); guide.hidden = false; document.documentElement.style.overflow = "hidden"; guide.querySelector("[data-guide-close]").focus(); };
    const closeGuide = () => { guide.hidden = true; document.documentElement.style.overflow = ""; };
    root.querySelectorAll("[data-guide-open]").forEach((b) => b.addEventListener("click", openGuide));
    guide.querySelectorAll("[data-guide-close]").forEach((b) => b.addEventListener("click", closeGuide));
    guide.addEventListener("click", (e) => { if (e.target === guide) closeGuide(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !guide.hidden) closeGuide(); });
    document.body.appendChild(guide); // escape any transformed parent so the overlay covers the viewport

    const closePickers = () => pickers.forEach((p) => { p.menu.hidden = true; p.trigger.setAttribute("aria-expanded", "false"); });

    /* ---------- custom dropdowns (size + stones, with stone thumbnails) ---------- */
    root.querySelectorAll("select").forEach((select, index) => {
      const stone = !select.hasAttribute("data-size");
      const kind = stone ? "svb-stone-picker" : "svb-size-picker";
      const picker = document.createElement("div");
      picker.className = kind;
      picker.dataset.bundlePicker = "";

      const trigger = document.createElement("button");
      trigger.type = "button";
      trigger.className = kind + "__button";
      trigger.setAttribute("aria-haspopup", "listbox");
      trigger.setAttribute("aria-expanded", "false");
      const label = select.closest("label, div").querySelector(".svb__label");
      label.id = root.id + "-label-" + index;
      trigger.setAttribute("aria-labelledby", label.id + " " + root.id + "-value-" + index);

      const preview = document.createElement("img");
      preview.alt = ""; preview.hidden = true; preview.width = 24; preview.height = 24;
      const value = document.createElement("span");
      value.className = kind + "__value";
      value.id = root.id + "-value-" + index;
      const caret = document.createElement("span");
      caret.className = kind + "__caret";
      caret.setAttribute("aria-hidden", "true");
      trigger.append(preview, value, caret);

      const menu = document.createElement("div");
      menu.className = kind + "__menu";
      menu.setAttribute("role", "listbox");
      menu.setAttribute("aria-labelledby", label.id);
      menu.hidden = true;

      const fieldError = document.createElement("span");
      fieldError.className = "svb__field-error";
      fieldError.hidden = true;
      fieldError.textContent = select.options[0].textContent;

      const choices = [];
      [...select.options].filter((o) => o.value !== "").forEach((option) => {
        const choice = document.createElement("button");
        choice.type = "button";
        choice.className = kind + "__option";
        choice.setAttribute("role", "option");
        if (stone) {
          option.dataset.image = config.stones[Number(option.value)];
          const img = document.createElement("img");
          img.src = option.dataset.image; img.alt = ""; img.width = 32; img.height = 32; img.loading = "lazy";
          choice.append(img);
        }
        const text = document.createElement("span");
        text.textContent = option.textContent;
        choice.append(text);
        /* la mention n'apparait QUE dans la liste ouverte, jamais sur le bouton ferme */
        if (option.dataset.note) {
          const note = document.createElement("small");
          note.className = kind + "__note";
          note.textContent = option.dataset.note;
          choice.append(note);
        }
        menu.append(choice);
        choices.push({ choice, option });
        choice.addEventListener("click", () => {
          if (busy || option.disabled) return;
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
          closePickers();
          trigger.focus();
        });
      });

      /* le bouton fermé affiche l'abrégé ("Nov.", "US 11"), le menu garde les noms complets */
      const court = (option) => {
        if (!option || option.value === "") return option ? option.textContent : "";
        if (stone) return CORTOS[Number(option.value)] || option.textContent;
        const m = option.textContent.match(/US \d+/);
        return m ? m[0] : option.textContent;
      };
      const update = () => {
        const selected = select.selectedOptions[0];
        value.textContent = court(selected);
        preview.hidden = !(selected && selected.dataset.image);
        if (!preview.hidden) preview.src = selected.dataset.image;
        trigger.disabled = select.matches(":disabled");
        const invalid = select.getAttribute("aria-invalid") === "true";
        trigger.setAttribute("aria-invalid", String(invalid));
        fieldError.hidden = !invalid || trigger.disabled;
        choices.forEach(({ choice, option }) => {
          choice.disabled = option.disabled;
          choice.setAttribute("aria-selected", String(option.value === select.value));
        });
        if (trigger.disabled) { menu.hidden = true; trigger.setAttribute("aria-expanded", "false"); }
      };

      trigger.addEventListener("click", () => {
        const open = menu.hidden;
        closePickers();
        menu.hidden = !open;
        trigger.setAttribute("aria-expanded", String(open));
      });
      picker.addEventListener("keydown", (event) => {
        const available = choices.map((c) => c.choice).filter((c) => !c.disabled);
        if (event.key === "Escape") { event.preventDefault(); closePickers(); trigger.focus(); }
        else if (["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
          event.preventDefault();
          menu.hidden = false; trigger.setAttribute("aria-expanded", "true");
          const i = available.indexOf(document.activeElement);
          const next = event.key === "Home" ? 0 : event.key === "End" ? available.length - 1
            : event.key === "ArrowDown" ? (i + 1) % available.length : i <= 0 ? available.length - 1 : i - 1;
          if (available[next]) available[next].focus();
        }
      });
      picker.addEventListener("focusout", (event) => {
        if (!picker.contains(event.relatedTarget)) { menu.hidden = true; trigger.setAttribute("aria-expanded", "false"); }
      });

      picker.append(trigger, menu);
      select.after(picker);
      picker.after(fieldError);
      select.hidden = true;
      select.tabIndex = -1;
      select.setAttribute("aria-hidden", "true");
      select.addEventListener("change", update);
      select._trigger = trigger;
      pickers.push({ trigger, menu, update });
      update();
    });
    document.addEventListener("click", (event) => { if (!event.target.closest("[data-bundle-picker]")) closePickers(); });

    /* ---------- state ---------- */
    const selectedVariant = (ring) => {
      const color = ring.querySelector("[data-color][aria-pressed=true]").dataset.color;
      const size = ring.querySelector("[data-size]").value;
      return config.variants.find((v) => v.option1 === color && v.option2 === size);
    };
    const showError = (message) => { error.textContent = message; error.hidden = false; };

    /* l'apercu : les deux pierres COLLEES, comme sur la bague. Pas de separateur.
       Rendu differentiel : on ne touche que la pierre qui change, sinon ca scintille. */
    const renderPreview = (ring) => {
      const body = ring.querySelector("[data-preview-body]");
      if (!body) return;
      const left = ring.querySelector("[data-left]").value;
      const right = ring.querySelector("[data-right]").value;

      if (left === "" || right === "") {
        if (body.dataset.state !== "empty") {
          body.innerHTML = '<p class="svb__preview-empty">' + (t.previewEmpty || "") + "</p>";
          body.dataset.state = "empty";
        }
        return;
      }
      if (body.dataset.state !== "filled") {
        body.innerHTML =
          '<span class="svb__preview-pair">' +
            '<img data-side="left" alt="" width="44" height="44" loading="lazy">' +
            '<img data-side="right" alt="" width="44" height="44" loading="lazy">' +
          '</span>' +
          '<span class="svb__preview-names"><span data-name="left"></span><i>&middot;</i><span data-name="right"></span></span>';
        body.dataset.state = "filled";
      }
      [["left", left], ["right", right]].forEach(([side, index]) => {
        const img = body.querySelector('img[data-side="' + side + '"]');
        if (img.dataset.index === index) return;   // ce cote n'a pas bouge
        img.dataset.index = index;
        img.src = config.stones[Number(index)];
        body.querySelector('[data-name="' + side + '"]').textContent = MONTHS[Number(index)];
      });
    };

    const sync = () => {
      root.dataset.quantity = quantity;
      root.querySelectorAll(".svb__choice").forEach((b) => {
        b.setAttribute("aria-pressed", String(Number(b.dataset.quantity) === quantity));
        b.disabled = busy;
      });
      if (slot1 && slot2) {
        if (quantity === 1) { if (rings[0].parentElement !== slot1) slot1.appendChild(rings[0]); }
        else if (rings[0].parentElement !== slot2) slot2.insertBefore(rings[0], rings[1]);
      }
      root.querySelectorAll(".svb__offer").forEach((o) => {
        const b = o.querySelector(".svb__choice");
        if (b) o.classList.toggle("is-on", b.getAttribute("aria-pressed") === "true");
      });
      rings.forEach((ring, index) => {
        ring.hidden = index >= quantity;
        ring.disabled = index >= quantity || busy;
        renderPreview(ring);
        const color = ring.querySelector("[data-color][aria-pressed=true]").dataset.color;
        ring.querySelectorAll("[data-size] option").forEach((o) => {
          if (o.value) o.disabled = !config.variants.some((v) => v.option1 === color && v.option2 === o.value && v.available);
        });
        const v = selectedVariant(ring);
        const note = ring.querySelector("[data-availability]");
        note.hidden = !v || v.available;
        note.textContent = t.unavailable;
      });
      button.disabled = busy;
      button.textContent = busy ? t.busy : (quantity === 2 ? t.two : t.one);
      pickers.forEach((p) => p.update());
    };

    root.querySelectorAll(".svb__choice").forEach((b) => b.addEventListener("click", () => {
      if (busy) return;
      quantity = Number(b.dataset.quantity);
      error.hidden = true;
      sync();
    }));

    rings.forEach((ring) => {
      ring.querySelectorAll("[data-color]").forEach((b) => b.addEventListener("click", () => {
        if (busy) return;
        ring.querySelectorAll("[data-color]").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
        ring.querySelector("[data-color-label]").textContent = V_(b.dataset.color);
        if (ring === rings[0]) refleter();
        sync();
      }));
      ring.querySelectorAll("select").forEach((s) => s.addEventListener("change", () => {
        s.removeAttribute("aria-invalid");
        error.hidden = true;
        if (ring === rings[0] && !enMiroir) refleter();
        sync();
      }));
      if (ring === rings[1]) ring.addEventListener("click", (e) => {
        if (enMiroir) return;
        if (e.target.closest(".svb__swatch")) { touche2.color = true; return; }
        const picker = e.target.closest("[data-bundle-picker]");
        if (picker && e.target.closest('[role="option"], [class*="__option"]')) {
          const sel = picker.previousElementSibling;
          const n = sel && sel.name;
          if (n === "size-2") touche2.size = true;
          else if (n === "left-2") touche2.left = true;
          else if (n === "right-2") touche2.right = true;
        }
      }, true);
    });

    /* ---------- add to cart → Revive (LuminTheme) cart drawer ---------- */
    const refreshDrawer = async (data) => {
      const drawer = document.querySelector("cart-drawer");
      if (!drawer || typeof drawer.renderContents !== "function") {
        window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
        return;
      }
      const ids = drawer.getSectionsToRender().map((s) => s.id);
      if (!data.sections || ids.some((id) => !data.sections[id])) {
        const r = await fetch(`${window.location.pathname}?sections=${ids.join(",")}`);
        data = { sections: await r.json() };
      }
      drawer.classList.remove("is-empty");
      drawer.renderContents(data);
      drawer.open();
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        const cart = await fetch((window.routes ? window.routes.cart_url : "/cart") + ".js").then((r) => r.json());
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "elora-bundle", cartData: cart });
      }
    };

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (busy) return;
      error.hidden = true;

      const active = rings.slice(0, quantity);
      const fields = active.flatMap((r) => [...r.querySelectorAll("select")]);
      const missing = fields.filter((s) => s.value === "");
      fields.forEach((s) => s.setAttribute("aria-invalid", String(missing.includes(s))));
      pickers.forEach((p) => p.update());
      if (missing.length) { showError(t.required); missing[0]._trigger.focus(); return; }

      const items = active.map((r) => {
        const variant = selectedVariant(r);
        if (!variant || !variant.available) return null;
        return {
          id: variant.id,
          quantity: 1,
          properties: {
            [L_.propLeft || "Left birthstone"]: MONTHS[Number(r.querySelector("[data-left]").value)],
            [L_.propRight || "Right birthstone"]: MONTHS[Number(r.querySelector("[data-right]").value)],
            // codigo de taller: el prefijo _ lo oculta al cliente, sigue en el admin y en los exports
            "_stone_ref": pad(r.querySelector("[data-left]").value) + " / " + pad(r.querySelector("[data-right]").value)
          }
        };
      });
      if (items.some((i) => !i)) { showError(t.unavailable); return; }

      busy = true;
      sync();
      try {
        const drawer = document.querySelector("cart-drawer");
        const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
        // the cart lists the last line added first: send ring 2 first so ring 1 sits on top
        const response = await fetch((window.routes ? window.routes.cart_add_url : "/cart/add") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items.slice().reverse(), sections, sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || t.error);
        await refreshDrawer(data);
      } catch (e) {
        showError(e.message || t.error);
      } finally {
        busy = false;
        sync();
      }
    });

    sync();
  });
})();
